var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSquares2X2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 3H6V6H3V3ZM1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H6C6.82843 1.5 7.5 2.17157 7.5 3V6C7.5 6.82843 6.82843 7.5 6 7.5H3C2.17157 7.5 1.5 6.82843 1.5 6V3ZM3 10H6V13H3V10ZM1.5 10C1.5 9.17157 2.17157 8.5 3 8.5H6C6.82843 8.5 7.5 9.17157 7.5 10V13C7.5 13.8284 6.82843 14.5 6 14.5H3C2.17157 14.5 1.5 13.8284 1.5 13V10ZM13 3H10V6H13V3ZM10 1.5C9.17157 1.5 8.5 2.17157 8.5 3V6C8.5 6.82843 9.17157 7.5 10 7.5H13C13.8284 7.5 14.5 6.82843 14.5 6V3C14.5 2.17157 13.8284 1.5 13 1.5H10ZM10 10H13V13H10V10ZM8.5 10C8.5 9.17157 9.17157 8.5 10 8.5H13C13.8284 8.5 14.5 9.17157 14.5 10V13C14.5 13.8284 13.8284 14.5 13 14.5H10C9.17157 14.5 8.5 13.8284 8.5 13V10Z",
  fill: "currentColor"
})));
export default SvgSquares2X2;